import React from 'react';

const VersionUpdateToast = ({ onRefresh }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <span>
        We've released a new version of EnvestHub and need you to refresh. If
        you are typing anything, please take note of it or copy it. Then refresh
        the page manually or click this notice to refresh.
      </span>
    </div>
  );
};

export default VersionUpdateToast;
